import {EMAIL_REGEX} from 'constants/index';
import {msg} from 'utils/functions';
import * as Yup from 'yup';

export const validationSchema = (
	Yup.object({
		firstName: Yup.string()
			.trim()
			.required(msg('first name')),

		lastName: Yup.string()
			.trim()
			.required(msg('last name')),

		email: Yup.string()
			.trim()
			.matches(EMAIL_REGEX, msg('email'))
			.required(msg('email')),
	})
);
